export function getOffice(data) {
    let { getOfficeRequest, getOfficeError, getOfficeResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'get_office',
        this.createBundle('get_office', { office: data }, this.GET, getOfficeRequest, getOfficeResult, getOfficeError)
    )
}
